import algoliasearch from 'algoliasearch'
import { AlgoliaConstants } from '../helpers/Constants'

const clients = {
  search: null,
  write: null
}

export const getSearchClient = () => {
  if (!process.env.ALGOLIA_APP_ID || !process.env.ALGOLIA_APP_SEARCH_KEY) {
    throw new Error(AlgoliaConstants.errorMsg)
  }

  if (!clients.search) {
    clients.search = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_APP_SEARCH_KEY)
  }

  return clients.search
}

